import { IRestCardAssigneeInfo } from '../../../../types/rest/IRestCardAssigneeInfo';
import { ThunkAction } from '../../../../types/actions';
import { TCardId } from '../../../../types/types';
import { REST_CARDS_ASSIGNED_TO_ME } from '../../../constants';
import { fetchHandler } from '../../../../util/fetchHandler';
import Util from '../../../../util/util';
import { getRestHeadersPatch } from '../../../helpers/getRestHeadersHelper';

export const patchRest = (
    cardId: TCardId,
    body: IRestCardAssigneeInfo
): ThunkAction => {
    const action = () => {
        return fetchHandler<any>(
            Util.getApiUrl(REST_CARDS_ASSIGNED_TO_ME + '/' + cardId), {
                ...getRestHeadersPatch(),
                body: JSON.stringify(body)
            }
        );
    };
    return action;
}
